import { useMemo } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getCustomerFiles } from '../../services/customers';

function useGetCustomerFiles({
  customerId,
  businessId,
}: {
  customerId: string;
  businessId: string;
}) {
  const query = useInfiniteQuery({
    queryKey: ['customer-files-tab', { customerId, businessId }],
    queryFn: ({ pageParam }) =>
      getCustomerFiles({ customerId, businessId, cursor: pageParam }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: lastPage => lastPage.nextCursor ?? undefined,
    enabled: !!customerId && !!businessId,
  });

  const pages = query.data?.pages;
  const files = useMemo(
    () => pages?.flatMap(page => page.files) ?? [],
    [pages],
  );

  return {
    files,
    isInitialLoading: query.isPending,
    isFetching: query.isFetching,
    isFetchingNextPage: query.isFetchingNextPage,
    hasMore: query.hasNextPage,
    loadMore: () => {
      query.fetchNextPage();
    },
    isError: query.isError && !query.data,
    isFetchNextPageError: query.isFetchNextPageError,
    error: query.error,
  };
}

export default useGetCustomerFiles;
